<div class="top-strip"></div>
<router-outlet></router-outlet>